<template>
  <footer class="bg-gray-900 text-white pt-16 pb-8">
    <div class="container mx-auto px-4">
      <div class="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
        <!-- Logo and Description -->
        <div class="col-span-1 md:col-span-1">
          <div class="flex items-center mb-6">
            <div class="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg flex items-center justify-center shadow-lg">
              <span class="text-white font-bold text-xl">Y</span>
            </div>
            <span class="ml-2 text-2xl font-bold text-white">Yisur</span>
          </div>
          <p class="text-gray-400 leading-relaxed text-sm">
            Yisur云手机是一款专为跨境电商和社交媒体营销打造的多功能软件，提供了丰富的功能来帮助用户高效管理和操作多个设备。
          </p>
        </div>

        <!-- Quick Links -->
        <div class="col-span-1">
          <h3 class="text-lg font-semibold mb-6 text-white border-b-2 border-blue-600 inline-block pb-1">快速链接</h3>
          <ul class="space-y-3">
            <li><router-link to="/" class="text-gray-400 hover:text-blue-400 transition-colors flex items-center"><span class="mr-2">›</span>主页</router-link></li>
            <li><router-link to="/about" class="text-gray-400 hover:text-blue-400 transition-colors flex items-center"><span class="mr-2">›</span>关于我们</router-link></li>
            <li><router-link to="/features" class="text-gray-400 hover:text-blue-400 transition-colors flex items-center"><span class="mr-2">›</span>功能特点</router-link></li>
            <li><router-link to="/pricing" class="text-gray-400 hover:text-blue-400 transition-colors flex items-center"><span class="mr-2">›</span>定价方案</router-link></li>
          </ul>
        </div>

        <!-- Resources -->
        <div class="col-span-1">
          <h3 class="text-lg font-semibold mb-6 text-white border-b-2 border-blue-600 inline-block pb-1">支持资源</h3>
          <ul class="space-y-3">
            <li><a href="#" class="text-gray-400 hover:text-blue-400 transition-colors flex items-center"><span class="mr-2">›</span>帮助中心</a></li>
            <li><a href="#" class="text-gray-400 hover:text-blue-400 transition-colors flex items-center"><span class="mr-2">›</span>开发文档</a></li>
            <li><a href="#" class="text-gray-400 hover:text-blue-400 transition-colors flex items-center"><span class="mr-2">›</span>API参考</a></li>
            <li><a href="#" class="text-gray-400 hover:text-blue-400 transition-colors flex items-center"><span class="mr-2">›</span>系统状态</a></li>
          </ul>
        </div>

        <!-- Contact Info -->
        <div class="col-span-1">
          <h3 class="text-lg font-semibold mb-6 text-white border-b-2 border-blue-600 inline-block pb-1">联系我们</h3>
          <ul class="space-y-4">
            <li class="flex items-start group">
              <div class="w-8 h-8 rounded-full bg-gray-800 flex items-center justify-center mr-3 group-hover:bg-blue-600 transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-blue-400 group-hover:text-white transition-colors" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <div>
                <span class="block text-xs text-gray-500 mb-1">电子邮箱</span>
                <span class="text-gray-300 hover:text-white transition-colors">wang_11_master@126.com</span>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <!-- Social Media and Copyright -->
      <div class="mt-12 pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center">
        <div class="flex space-x-4 mb-4 md:mb-0">
          <a href="#" class="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center text-gray-400 hover:bg-blue-600 hover:text-white transition-all transform hover:-translate-y-1">
            <svg class="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
              <path d="M21.35 11.1h-9.17v2.73h6.51c-.33 3.81-3.5 5.44-6.5 5.44C8.36 19.27 5 16.25 5 12c0-4.1 3.2-7.27 7.2-7.27 3.09 0 4.9 1.97 4.9 1.97L19 4.72S16.56 2 12.1 2C6.42 2 2.03 6.8 2.03 12c0 5.05 4.13 10 10.22 10 5.35 0 9.25-3.67 9.25-9.09 0-1.15-.15-1.81-.15-1.81z"></path>
            </svg>
          </a>
        </div>
        <div class="text-gray-500 text-sm text-center md:text-right">
          <p class="mb-2">© {{ new Date().getFullYear() }} Yisur云手机. 保留所有权利.</p>
          <div class="flex space-x-4 text-xs justify-center md:justify-end">
            <a href="#" class="hover:text-white transition-colors">隐私政策</a>
            <a href="#" class="hover:text-white transition-colors">服务条款</a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script> 